export enum StoreKeys {
	app = 'app',
	questionnaireTemplate = 'questionnaireTemplate',
}
